
import { useState } from 'react';
import React from 'react';
import CanvasLayout from './CanvasLayout';


function CanvasLayoutContainer(props) {
    const [isSettingsOpen, setIsSettingsOpen] = useState(true);

    // we'll use this later
    const toggleSettingsPanel = () => {
        setIsSettingsOpen((prev) => !prev);
    };

    const currentDate = new Date().toLocaleDateString();
    const title = `${props.options.title} - ${currentDate}`;


    return (<CanvasLayout {...props} toggleSettingsPanel={toggleSettingsPanel} isSettingsOpen={isSettingsOpen} setIsSettingsOpen={setIsSettingsOpen} title={title} />);
}

export default CanvasLayoutContainer;